import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import TheWebPage from "./components/TheWebPage.jsx";
import "./styles/index.css";

// Design-preview hatch: render isolated pages via ?preview=<name>.
// Useful for iterating on hero features without going through auth.
const params = new URLSearchParams(window.location.search);
const preview = params.get("preview");

let entry = (
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

if (preview === "web") {
  document.body.setAttribute("data-theme", "dark");
  entry = (
    <React.StrictMode>
      <ErrorBoundary>
        <div style={{ background: "#0a0a0c", minHeight: "100vh", padding: 12 }}>
          <TheWebPage />
        </div>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(entry);
